import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["type", "children"];
import React from 'react';
import { Link } from 'gatsby';
import styled from '@xstyled/styled-components';
export var InnerSiblingNavLink = styled.aBox.withConfig({
  displayName: "SiblingNav__InnerSiblingNavLink",
  componentId: "sc-fvf3xf-0"
})(["font-size:18;transition:fast;text-decoration:underline;color:on-background-primary;&:hover{color:on-background-primary-dark;}&[data-type='next']:hover{transform:translateX(2px);}&[data-type='previous']:hover{transform:translateX(-2px);}"]);
export var SiblingNavLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var type = _ref.type,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(InnerSiblingNavLink, Object.assign({
    ref: ref,
    as: Link,
    "data-type": type,
    gridArea: type
  }, props), type === 'previous' && '← ', children, type === 'next' && ' →');
});
export var SiblingNav = styled.navBox.withConfig({
  displayName: "SiblingNav",
  componentId: "sc-fvf3xf-1"
})(["display:grid;grid-template-areas:'previous next';justify-content:space-between;margin:5 0;"]);